/**
 * The user-facing texts. Each language has one JSON file per area of the app
 * (`locales/<language>/<area>.json`), with its keys sorted. The file name is the area's key,
 * so merging the files gives the one `common` namespace every component reads; adding an
 * area means adding a file, never touching the components.
 *
 * English is the source text. German is translated in one pass once the English settles.
 */
export type LocaleTree = Readonly<Record<string, unknown>>;

type LocaleFiles = Record<string, { readonly default: LocaleTree }>;

/** `{ area: tree }` from `{ "./locales/en/area.json": { default: tree } }`. */
export function mergeAreas(files: LocaleFiles): LocaleTree {
  const merged: Record<string, LocaleTree> = {};
  for (const [path, module] of Object.entries(files)) {
    const area = path.slice(path.lastIndexOf("/") + 1, -".json".length);
    merged[area] = module.default;
  }
  return merged;
}

export const ENGLISH_FILES = import.meta.glob<{ default: LocaleTree }>("./locales/en/*.json", {
  eager: true,
});
export const GERMAN_FILES = import.meta.glob<{ default: LocaleTree }>("./locales/de/*.json", {
  eager: true,
});

export const ENGLISH: LocaleTree = mergeAreas(ENGLISH_FILES);
export const GERMAN: LocaleTree = mergeAreas(GERMAN_FILES);
